import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/anchor';
import '../general/warning';
import '../general/up';

import '../pages/reviews/reviews';
import '../pages/reviews/modal-review';
import '../pages/reviews/modal-review-select';
import '../pages/reviews/modal-review-rating';
import '../pages/reviews/modal-review-button';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/reviews.js